<template>
  <div id="jack-monthly-calendar" class="text-3xl">

    <div v-if="!jackDataLoaded" class="text-center"> ... </div>

    <template v-if="jackDataLoaded">


      <!-- FILTERS -->
      <template v-if="filters.length >= 1">
        <select v-model="filter0_selected" class="select-cat1 filter-1 round p-4">
          <option :value="null">{{ filters[0].name}}</option>
          <option v-for="val in filters[0].values_allowed" :value="val">{{ val }}</option>
        </select>
      </template>

      <template v-if="filters.length >= 2">
        <select v-model="filter1_selected" class="select-cat1 filter-2 round p-4">
          <option :value="null">{{ filters[1].name}}</option>
          <option v-for="val in filters[1].values_allowed" :value="val">{{ val }}</option>
        </select>
      </template>

      <template v-if="filters.length >= 3">
        <select v-model="filter2_selected" class="select-cat1 filter-3 round p-4">
          <option :value="null">{{ filters[2].name}}</option>
          <option v-for="val in filters[2].values_allowed" :value="val">{{ val }}</option>
        </select>
      </template>



      <!-- MONTH SELECTOR -->
      <div class="calendar-change-month flex flex-row items-center justify-center gap-4 select-none">
        <svg @click="prevMonth" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="cursor-pointer w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
        <div>{{ formattedDate }}</div>
        <svg @click="nextMonth" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="cursor-pointer w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </div>


      <!-- CALENDAR VIEW slot content -->
      <ApsCalendar :year="year" :month="month" v-slot="slotProps">

        <div class="jack-day-classes text-sm px-1">
          <!-- div class="absolute top-0 right-0">{{ slotProps.day.dateFormat }}</div -->

          <div v-if="slotProps.day.weekday >= 6" class="p-2" v-html="message_weekends"></div>

          <div v-for="item in getClassesFor(slotProps.day)"
               @click="selectClass(item)"
               :style="{border: '3px solid black', background: getBakgroundColor(item)}"
               class="jack-day-class my-1 cursor-pointer hover:color-black hover:bg-yellow-200 rounded-md p-2"
          >
            <div>{{ formatTime(item.start_time) }} - {{ formatTime(item.end_time) }}</div>
            <div class="font-bold text-black">{{ item.name }}</div>
            <div class="jack-class-details">
              <div class="text-indigo-500 text-xs">{{item.min_age}}-{{item.max_age}}</div>
              <div class="text-indigo-500 text-xs">{{item.start_time}}</div>
              <div class="text-red-500 text-xs">{{item.category1}}</div>
              <div class="text-red-500 text-xs">{{item.category2}}</div>
              <div class="text-red-500 text-xs">{{item.category3}}</div>
              <div class="text-red-500 text-xs">ROOM: {{item.room}}</div>
            </div>

            <!-- img class="w-full h-auto rounded-md mt-1" :src="getImageForTitle(item.name)" -->
            <!-- img class="w-full h-auto rounded-md mt-1" :src="getImageForClassItem(item)" -->

          </div>
        </div>

      </ApsCalendar>


    </template>

  </div>


  <!-- MODAL VIEW -->
  <Modal v-if="showModal" @close="showModal = false">

    <div id="jackcalendar-modal-content-inner" class="bg-white relative rounded-xl" :style="{border: '8px solid black'}">

      <div class="absolute top-2 right-2 cursor-pointer hover:opacity-80" @click="showModal = false">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>

      <div class="p-4 pt-12">

        <div class="font-bold text-black text-xl mt-2">{{ classSelected.name }}</div>

        <!-- img class="w-full h-auto rounded-md max-w-[640px] mt-2" :src="getImageForTitle(classSelected.name)" -->
        <!-- img class="w-full h-auto rounded-md max-w-[640px] mt-2" :src="getImageForClassItem(classSelected)" -->

        <div class="mt-4 text-black" v-html="classSelected.description"></div>

        <div class="flex flex-row items-start justify-between mt-4">
          <div class="">
            <div class="flex flex-row items-center gap-2">
              <div v-if="classSelected.start_date">Date: {{ formatDate(classSelected.start_date)}}</div>
              <div v-if="classSelected.end_date && classSelected.start_date != classSelected.end_date">- {{ formatDate(classSelected.end_date)}}</div>
            </div>
            <div class="flex flex-row items-center gap-2">
              <div v-if="classSelected.start_time">Time: {{ formatTime(classSelected.start_time)}}</div>
              <div v-if="classSelected.end_time">- {{ formatTime(classSelected.end_time)}}</div>
            </div>

          </div>
          <div v-if="classSelected.tuition && classSelected.tuition.fee" class="font-bold text-black">
            {{ isClassRecurring(classSelected) ? label_monthly_tuition : label_tutition}}: ${{ classSelected.tuition.fee }}
          </div>
        </div>


        <div v-if="hasRegisterLink(classSelected)" class="text-center mt-4">
          <a :href="getRegisterLink(classSelected)" target="_blank" class="jack-register-button">
            {{ registerButton }}
          </a>
        </div>

      </div>

    </div>
  </Modal>

</template>

<script>
import {sortBy, map} from "lodash";
import ApsCalendar from "./components/ApsCalendar";
import JackrabbitData from "@shared/mixins/JackrabbitData";
import Modal from "./components/Modal";

export default {
  mixins: [JackrabbitData],

  components: {Modal, ApsCalendar},

  data(){
    return {
      year: 2000,
      month: 1,

      showModal: false,
      classSelected: null,
      message_weekends: JACKCA_CALENDAR.message_weekends,
      colors: JACKCA_CALENDAR.location_colors,
    }
  },

  created() {
    this.year = DateTime.now().toFormat('yyyy')
    this.month = DateTime.now().toFormat('M')
    this.getjacktabbitData()
  },

  computed: {
    formattedDate() {
      let date = DateTime.fromObject({ year: parseInt(this.year), month: parseInt(this.month), day: 1, hour: 12, minute: 30 })
      return date.setLocale('en').toFormat('MM/yyyy')
    },
    registerButton(){
      return this.classSelected?.openings?.calculated_openings > 0 ? 'Register' : 'Join Waitlist'
    },
    label_tutition(){
      return window.JACKCA_CALENDAR.fee_labels[0]
    },
    label_monthly_tuition(){
      return window.JACKCA_CALENDAR.fee_labels[1]
    }
  },

  methods: {
      prevMonth(){
        let month = parseInt(this.month)
        let year = parseInt(this.year)
        month -= 1
        if (month == 0) {
          month = 12
          year -= 1
        }
        this.month = month
        this.year = year
      },
      nextMonth(){
        let month = parseInt(this.month)
        let year = parseInt(this.year)
        month += 1
        if (month > 12) {
          month = 1
          year += 1
        }
        this.month = month
        this.year = year
      },

    selectClass(item) {
        this.classSelected = item
        this.showModal = true
    },

    registerLink(link) {
      return link.replaceAll('&amp;', '&')
    },

    getBakgroundColor(item) {

      // Probar con name
      let extract_value = item.name.match(/(.+)-(.+)/)
      if (extract_value) {
        const location = extract_value[1].trim()
        if (this.colors[location]) {
          return this.colors[location].color
        }
      }
      // Y si no con room
      extract_value = item.room.match(/(.+)-(.+)/)
      if (extract_value) {
        const location = extract_value[1].trim()
        if (this.colors[location]) {
          return this.colors[location].color
        }
      }

      return 'white';
    },


  }
}
</script>

<style>

.select-cat1 {
  position: relative;
  font-size: 24px;
  line-height: 40px;
  background: #ffd100;
  text-align: center;
}
.select-cat1 {
  margin: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.select-cat1{
  appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23131313%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E");
  background-repeat: no-repeat;
  background-position: right 2rem top 50%;
  background-size: 0.65rem auto;
}

.select-cat1.round_ {
  background-image:
      linear-gradient(45deg, transparent 50%, gray 50%),
      linear-gradient(135deg, gray 50%, transparent 50%),
      radial-gradient(#ddd 70%, transparent 72%);
  background-position:
      calc(100% - 20px) calc(1em + 2px),
      calc(100% - 15px) calc(1em + 2px),
      calc(100% - .5em) .5em;
  background-size:
      5px 5px,
      5px 5px,
      1.5em 1.5em;
  background-repeat: no-repeat;
}

.calendar-change-month {
  padding: 20px;
  background: #02b9d6;
  color: white;
}

/*.jack-day-class {
  border: 1px solid #b8b85d;
  background: #f8f8ca;
}*/
.jack-register-button {
  font-size: 30px;
  font-weight: bold;
  background-color: #00B9D6FF;
  padding: 10px;
  color: white;
  text-decoration: none;
  border-bottom-left-radius: 49% 54%;
  border-bottom-right-radius: 51% 54%;
  border-top-left-radius: 71% 46%;
  border-top-right-radius: 29% 46%;
  padding-bottom: 15px;
  padding-left: 45px;
  padding-right: 45px;
  padding-top: 15px;
}
</style>
